export const config = {
    "version": 2,
    "logging": {
        "logLevel": "info"
    },
    "scopes": [process.env.REACT_APP_SCOPE || 'api://CLIENT_ID/.default'],
    "authentication": {
        "clientId": process.env.REACT_APP_CLIENT_ID || "CLIENT_ID",
        "authority": process.env.REACT_APP_AUTHORITY || "https://login.microsoftonline.com/TENANT_ID",
        "tenantId": process.env.REACT_APP_TENANT_ID || "TENANT_ID",
    }
};
